module.exports = __webpack_public_path__ + "img/card-bg-only-salesperson.f40e92ba.jpg";